<script setup lang="ts">
import type { NuxtLinkProps } from '#app'

interface CardTreatmentProps {
  title?: string
  description?: string
  excerpt?: string
  to?: NuxtLinkProps['to']
}

defineProps<CardTreatmentProps>()
</script>

<template>
  <article class="card group-buttonLink relative lg:h-full">
    <div class="p-4 motion-snug rounded-2 bg-ivory flex flex-col h-full min-h-64 lg:p-6 @hover:bg-ivory/60 focus-within:bg-ivory/60">
      <Anchor v-if="to" class="inset-0 absolute z-1" :to :aria-label="title" />
      <Text as="h3" :text="title" class="typo-sans-2 min-h-10 uppercase line-clamp-2" />
      <div class="mt-auto relative">
        <Text v-if="excerpt" :text="excerpt" class="typo-serif-1 my-5 pb-0.5 line-clamp-3" />
        <Text v-else-if="description" :html="description" class="typo-serif-1 my-5 pb-0.5 line-clamp-3" />
        <ButtonLink as="span" :title="$t('discover_more')" />
      </div>
    </div>
  </article>
</template>
